import React from "react";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import Home from "../components/home/Home";
function HomePage() {
  return (
    <main>
     
        <Header/>
        <Home/>
        <Footer/>
    </main>
  );
}

export default HomePage;
